<template>
	<ContractListOnline :lieuMonteId="tiers.tiers_id" />
</template>

<script type="text/javascript">
	export default {
		name: "ContractTiersLieuMonteOnline",
		props: ['tiers'],
		components: {
			ContractListOnline: () => import('@/components/Contract/ContractListOnline')
		}
	}
</script>
